/**
 * Deadline/Fristen Events - Betrieb Müller (v2)
 *
 * Time-sensitive deadline events that don't fit other categories.
 */

import type { MockControlEvent } from '@hofsync/design-system';
import { hoursAgo, daysFromNow } from '../farm-profile';
import { ENERGIESTG_57 } from '../../legal';

/**
 * Event 3 (NOW - Shown): Agrardiesel Antrag (WARNING)
 */
export const EVENT_AGRARDIESEL_FRIST: MockControlEvent = {
  id: 'evt-agrardiesel-frist',
  type: 'obligation-due',
  priority: 'warning',
  title: 'Agrardiesel-Antrag: Frist in 9 Tagen',
  subtitle: 'Steuerentlastung',
  timestamp: hoursAgo(6),
  relevantDate: daysFromNow(9), // Due 04.02.2026
  relatedEntity: { name: 'Agrardiesel 2025', href: '#agrardiesel' },
  categories: ['fristen'],
  controlType: 'Steuerantrag',

  // === TWO-COLUMN LAYOUT ===
  isAggregate: true,
  hideAggregateBadge: true,
  affectedEntities: [
    {
      id: 'doc-agrardiesel-2025',
      name: 'Agrardiesel-Antrag 2025',
      type: 'deadline',
      severity: 'warning',
      status: 'Frist: 04.02.2026',
      action: { label: 'Antrag vorbereiten', href: '/my-farm/documents/agrardiesel' },
    },
  ],
  domainLink: {
    label: 'Kraftstoffverbrauch anzeigen',
    href: '/my-farm/fuel',
  },

  // === WHY THIS MATTERS ===
  reasoning: {
    summary: 'Agrardiesel-Antrag bis 04.02.2026 beim Hauptzollamt einreichen.',
    legalBasis: [ENERGIESTG_57],
    factors: [
      { label: 'Frist', value: '04.02.2026' },
      { label: 'Verbrauch 2025', value: 'ca. 10.000 L' },
      { label: 'Entlastungssatz', value: '21,48 ct/L' },
      { label: 'Geschätzte Erstattung', value: 'ca. 2.150 €' },
    ],
    confidence: 'high',
  },
  entities: [],
};

/**
 * All deadline events
 */
export const DEADLINE_EVENTS: MockControlEvent[] = [EVENT_AGRARDIESEL_FRIST];
